import axios from 'axios';

const version = 'v1';
const basePath = 'preparation-order';

export async function pick(reference) {
  return axios.request({
    url: `/${version}/${basePath}/${reference}/pick`,
    method: 'get',
  });
}

export async function getCounter(reference) {
  return axios.request({
    url: `/${version}/${basePath}/${reference}/counter`,
    method: 'get',
  });
}

export async function getAll({
  agency_id,
  warehouse_id,
  status,
  groupIdFilters,
  is_marketplace,
  marketplace_id,
  page = 1,
  itemsPerPage = 100,
}) {
  return axios.request({
    url: `/${version}/${basePath}/list`,
    method: 'get',
    params: {
      order_by: 'id',
      order_mode: 'desc',
      ...(status.length && {
        status: {
          in: status.join(','),
        },
      }),
      ...(warehouse_id && {
        warehouse_id,
      }),
      ...(agency_id.length && {
        agency_id: {
          in: agency_id.join(','),
        },
      }),
      ...(groupIdFilters && {
        group_id: { ...groupIdFilters },
      }),
      ...(is_marketplace && {
        marketplace_id: {
          not: '__null__',
        },
      }),
      ...(marketplace_id && {
        marketplace_id,
      }),
      limit: itemsPerPage,
      skip: itemsPerPage * (page - 1),
    },
  });
}

/** @deprecated */
export async function getPending(skip, limit) {
  return axios.request({
    url: `/${version}/${basePath}/pending`,
    method: 'get',
    params: {
      skip,
      limit,
    },
  });
}

export async function setAsPicking(reference) {
  return axios.request({
    url: `/${version}/${basePath}/set-as-picking`,
    method: 'put',
    params: {
      reference,
    },
  });
}

export async function setAsTransfer(reference) {
  return axios.request({
    url: `/${version}/${basePath}/set-as-transfer`,
    method: 'put',
    params: {
      reference,
    },
  });
}

export async function setAsClosed(reference) {
  return axios.request({
    url: `/${version}/${basePath}/set-as-closed`,
    method: 'put',
    params: {
      reference,
    },
  });
}

export async function create({
  request_id,
  recipient,
  agency_id,
  warehouse_id,
}) {
  return axios.request({
    url: `/${version}/${basePath}/`,
    method: 'post',
    data: {
      recipient,
      request_id,
      agency_id,
      warehouse_id,
    },
  });
}

export async function createForRetries({
  request_id,
  recipient,
  agency_id,
  warehouse_id,
}) {
  return axios.request({
    url: `/${version}/${basePath}/retries/`,
    method: 'post',
    data: {
      recipient,
      request_id,
      agency_id,
      warehouse_id,
    },
  });
}

export async function setAsWaiting(id) {
  return axios.request({
    url: `/${version}/${basePath}/set-as-waiting`,
    method: 'put',
    params: {
      id,
    },
  });
}

export async function transferToWarehouse({ references, warehouse_id }) {
  return axios.request({
    url: `/${version}/${basePath}/transfer-warehouse/`,
    method: 'put',
    data: {
      references,
      warehouse_id,
    },
  });
}

export async function updatePackages(reference, articles) {
  return axios.request({
    url: `/${version}/${basePath}/${reference}/update-packages/`,
    method: 'put',
    data: {
      articles,
    },
  });
}
